module.exports = __webpack_public_path__ + "static/woman-raising-hand-21e8b0aacc8672b8b1203ac055a5622c.png";